var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * PhoneMobile component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconPhoneMobile extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation"
        ><svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.25042 0.570801C5.61576 0.570801 5.00709 0.82292 4.55832 1.27169C4.10954 1.72047 3.85742 2.32914 3.85742 2.9638V21.0348C3.85742 21.6695 4.10954 22.2781 4.55832 22.7269C5.00709 23.1757 5.61576 23.4278 6.25042 23.4278H17.7504C18.3851 23.4278 18.9938 23.1757 19.4425 22.7269C19.8913 22.2781 20.1434 21.6695 20.1434 21.0348V2.9638C20.1434 2.32914 19.8913 1.72047 19.4425 1.27169C18.9938 0.82292 18.3851 0.570801 17.7504 0.570801H6.25042ZM5.61898 2.33235C5.78645 2.16488 6.01358 2.0708 6.25042 2.0708H17.7504C17.9873 2.0708 18.2144 2.16488 18.3819 2.33235C18.5493 2.49982 18.6434 2.72696 18.6434 2.9638V21.0348C18.6434 21.2716 18.5493 21.4988 18.3819 21.6662C18.2144 21.8337 17.9873 21.9278 17.7504 21.9278H6.25042C6.01358 21.9278 5.78644 21.8337 5.61898 21.6662C5.45151 21.4988 5.35742 21.2716 5.35742 21.0348V2.9638C5.35742 2.72696 5.45151 2.49982 5.61898 2.33235ZM11.1787 17.8208C10.7645 17.8208 10.4287 18.1566 10.4287 18.5708C10.4287 18.985 10.7645 19.3208 11.1787 19.3208H12.8217C13.2359 19.3208 13.5717 18.985 13.5717 18.5708C13.5717 18.1566 13.2359 17.8208 12.8217 17.8208H11.1787Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconPhoneMobile.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconPhoneMobile.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconPhoneMobile.prototype, "size", void 0);
if (customElements.get('cat-icon-phone-mobile') === undefined) {
    customElements.define('cat-icon-phone-mobile', BlocksIconPhoneMobile);
}
